import { DEFAULT_COUNT_ON_PAGE } from '@shared/ui/pagination/constants';
import { FeedbackRequestListDataRequest } from '../api/feedback-request-types';
import { DefaultSortOptionValues } from '@shared/ui/dropdown-sort/types';

export const DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS: FeedbackRequestListDataRequest = {
    take: DEFAULT_COUNT_ON_PAGE.value,
    sort: DefaultSortOptionValues.New,
    order: 'createdAt',
    my: true,
};
